
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hr",
      function () {
        return require("private-next-pages/hr/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hr"])
      });
    }
  